import React, {useEffect, useRef, useState} from "react";
import {useNavigate}                        from "react-router-dom";
import {InputText}                          from "primereact/inputtext";
import {Toast}                              from "primereact/toast";
import {confirmDialog}                      from "primereact/confirmdialog";
import {Button}                             from "primereact/button";
import {DataTable}                          from "primereact/datatable";
import {Column}                             from "primereact/column";
import {FilterMatchMode}                    from "primereact/api";

import {IdUsuarioLogado, UsuarioMaster}                          from "../../services/auth";
import {CabecalhoTabela, FundoSistema, Obrigatorio, TelaSistema} from "../../assets/style";
import Menu                                                      from "../../components/menu";
import api                                                       from "../../services/api";
import debug                                                     from "../../utils/debug";
import {InputMask}                                               from "primereact/inputmask";
import {Dropdown}                                                from "primereact/dropdown";

const Usuario = () => {
    const navegacao = useNavigate();
    const aviso = useRef(null);
    const endpointAPI = 'seguranca/usuario';
    const inicial = {id: 0, nome: '', email: '', idcliente: 2, idperfil: 2, senha: '', confirmaSenha: '', fone: '', mudarSenha: false};
    const [loading, setLoading] = useState(true);
    const [item, setItem] = useState(inicial);
    const [lista, setLista] = useState([]);
    const [listaClientes, setListaClientes] = useState([]);
    const [qtdeItens, setQtdeItens] = useState(0);
    const [pesquisaGeral, setPesquisaGeral] = useState(null);
    const [valorGlobalFiltro, setValorGlobalFiltro] = useState('');
    const [filtro, setFiltro] = useState({global: {value: null, matchMode: FilterMatchMode.CONTAINS}});

    useEffect(() => {
        if (!UsuarioMaster()) {
            navegacao('/sistema');
        } else {
            carregarItens();
            carregarCombos();
        }
    }, []);

    const carregarItens = async () => {
        setLoading(true);
        await new api().requisitar('get', endpointAPI).then((resposta) => {
            setLista(resposta);
            setQtdeItens(resposta?.length ?? 0);
            setLoading(false);
        }).catch((erro) => {
            debug(erro);
        });
    };

    const carregarCombos = async () => {
        await new api().requisitar('get', `/cadastro/cliente/combo`).then((resposta) => {
            setListaClientes(resposta ?? []);
        }).catch((erro) => {
            debug(erro);
        });
    }

    const limparTela = () => {
        setItem(inicial);
        carregarItens();
    };

    const excluir = async (id) => {
        await new api().requisitar('DELETE', `${endpointAPI}/${id}`).then((resposta) => {
            aviso.current.show({severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000});
            limparTela();
        }).catch((erro) => {
            debug(erro);
            aviso.current.show({
                                   severity: 'error',
                                   summary : 'Erro',
                                   detail  : (erro.response && erro.response.data && erro.response.data.error_description) ? erro.response.data.error_description : 'Ocorreu um erro não tratado',
                                   life    : 3000
                               });
        });
    };

    const aoMudarFiltroGlobal = (e) => {
        const value = e.target.value;
        let _filtro = {...filtro};
        _filtro['global'].value = value;

        setFiltro(_filtro);
        setValorGlobalFiltro(value);
    }

    const aoExcluirItem = (id) => {
        confirmDialog({
                          message    : `Confirma exclusão do usuário?`,
                          header     : 'Atenção',
                          icon       : 'pi pi-exclamation-triangle',
                          acceptLabel: 'Sim',
                          rejectLabel: 'Não',
                          accept     : () => {
                              excluir(id);
                          },
                      });
    };

    const aoSalvar = async () => {
        try {
            if (!item.idcliente) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Selecione um cliente!'};
            }

            if (!item.nome) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Informe o nome!'};
            }

            if (item.senha != item.confirmaSenha) {
                throw {tipo: 'warn', titulo: 'Atenção!!', mensagem: 'Senhas não conferem!'};
            }

            await new api().requisitar((item.id > 0) ? 'put' : 'post', (item.id > 0 ? `${endpointAPI}/${item.id ?? ''}` : endpointAPI), item).then((resposta) => {
                aviso.current.show({severity: 'success', summary: 'Confirmação', detail: resposta.mensagem, life: 3000});
                limparTela();
            }).catch((erro) => {
                throw {tipo: 'error', titulo: 'Falha!!', mensagem: erro.response.data ?? 'Ocorreu um erro não tratado'};
            });

        } catch (erro) {
            aviso.current.show({severity: erro.tipo ?? 'error', summary: erro.titulo ?? 'Erro', detail: erro.mensagem ?? erro, life: 3000});
        }
    };

    const aoDigitar = (e, propriedade) => {
        const texto = (e.target && e.target.value) || '';
        let _item = {...item};
        _item[`${propriedade}`] = texto;
        setItem(_item);
    };

    const cabecalhoTabela = (<React.Fragment>
        <CabecalhoTabela className='hidden md:flex'>
            <span className="m-0 text-lg">Usuários já cadastrados</span>
            <span className="p-input-icon-left">
                <i className="pi pi-search"/>
                <InputText value={valorGlobalFiltro} onChange={aoMudarFiltroGlobal} placeholder="Pesquise aqui"/>
            </span>
        </CabecalhoTabela>
        <div className='block md:hidden'>
            <div className='grid'>
                <div className="col-12">Usuários já cadastrados</div>
                <div className="col-12 p-input-icon-left">
                    <i className="pi pi-search"/>
                    <InputText value={valorGlobalFiltro} onChange={aoMudarFiltroGlobal} placeholder="Pesquise aqui"/>
                </div>
            </div>
        </div>
    </React.Fragment>);

    return (
        <FundoSistema>
            <Menu/>
            <Toast ref={aviso}></Toast>
            <TelaSistema title='Cadastro de Usuários'>
                <div className='grid'>
                    <div className="col-12">
                        <div className="field col-12 md:col-6">
                            <label htmlFor="idcliente">Cliente<Obrigatorio>*</Obrigatorio> </label><br/>
                            <Dropdown className="w-full" autoComplete="none" id="idcliente" value={item?.idcliente} options={listaClientes} onChange={(e) => aoDigitar(e, 'idcliente')} optionLabel="valor" optionValue="id" required/>
                        </div>
                    </div>

                    <div className="field col-12 md:col-6">
                        <label htmlFor="nome">Nome<Obrigatorio>*</Obrigatorio> </label><br/>
                        <InputText className="w-full" autoComplete="none" id="nome" maxLength={150} value={item.nome} onChange={(e) => aoDigitar(e, 'nome')} required/>
                    </div>
                    <div className="field col-12 md:col-6">
                        <label htmlFor="email">E-mail<Obrigatorio>*</Obrigatorio> </label><br/>
                        <InputText className="w-full" type='email' autoComplete="none" id="email" maxLength={150} value={item.email} onChange={(e) => aoDigitar(e, 'email')} required/>
                    </div>
                    <div className="field col-12 md:col-6 lg:col-4">
                        <label htmlFor="senha">Senha<Obrigatorio>*</Obrigatorio></label><br/>
                        <InputText className="w-full" autoComplete="off" type="password" id="senha" maxLength={50} value={item.senha} onChange={(e) => aoDigitar(e, 'senha')} required/>
                    </div>
                    <div className="field col-12 md:col-6 lg:col-4">
                        <label htmlFor="csenha">Confirmação de senha<Obrigatorio>*</Obrigatorio></label><br/>
                        <InputText className="w-full" autoComplete="off" type="password" id="csenha" maxLength={50} value={item.confirmaSenha} onChange={(e) => aoDigitar(e, 'confirmaSenha')} required/>
                    </div>
                    <div className="field col-12 md:col-6 lg:col-4">
                        <span className="hidden md:block">
                            <label htmlFor="nome">&nbsp;</label><br/>
                        </span>
                        <Button label="Salvar" severity='success' icon="pi pi-check" className="p-button-text mr-2" raised onClick={aoSalvar}/>
                        {item.id > 0 && <React.Fragment>
                            <Button label="Excluir" severity='danger' icon="pi pi-trash" className="p-button-text mr-2" raised onClick={(e) => aoExcluirItem(item.id)}/>
                            <Button label="Cancelar" severity='help' icon="pi pi-undo" className="p-button-text" raised onClick={(e) => setItem(inicial)}/>
                        </React.Fragment>}
                    </div>
                    <div className="field col-12">
                        <DataTable removableSort stripedRows
                                   value={lista} responsiveLayout='stack' globalFilterFields={['nome']} selectionMode='single'
                                   selection={item} onSelectionChange={(e) => setItem(e.value)} loading={loading}
                                   globalFilter={pesquisaGeral} filters={filtro} header={cabecalhoTabela}
                                   emptyMessage='Nenhum usuário cadastrado'>
                            <Column field={'cliente'} header={'Cliente'} sortable/>
                            <Column field={'nome'} header={'Nome'} sortable/>
                            <Column field={'email'} header={'E-mail'} sortable/>
                        </DataTable>
                    </div>
                </div>
            </TelaSistema>
        </FundoSistema>
    );
}

export default Usuario;